/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Collaborators: Patrick Barnum <patrick@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { MarkerWithLabel } from 'react-google-maps/lib/components/addons/MarkerWithLabel';
import { label } from './Map.module.scss';

const coloredMarkerDef = {
  svg: [
    '<svg viewBox="0 0 22 41" width="22px" height="41px" xmlns="http://www.w3.org/2000/svg">',
    '<path d="M 11,41 c -2,-20 -10,-22 -10,-30 a 10,10 0 1 1 20,0 c 0,8 -8,10 -10,30 z" fill="{fillColor}" stroke="#ffffff" stroke-width="1.5"/>',
    '<circle cx="11" cy="11" r="3"/>',
    '</svg>',
  ].join(''),
  anchor: { x: 11, y: 41 },
  size: { width: 22, height: 41 },
};

const getColoredMarkerSvg = color => coloredMarkerDef.svg.replace('{fillColor}', color);

const getColoredMarkerUri = color => `data:image/svg+xml,${encodeURIComponent(getColoredMarkerSvg(color))}`;

const getColoredMarkerIcon = color => ({
  url: getColoredMarkerUri(color),
  anchor: coloredMarkerDef.anchor,
  size: coloredMarkerDef.size,
  scaledSize: coloredMarkerDef.size,
});

type Props = {
  markerProps: Object,
  google: Object,
  messageComp: Object,
  position: { lat: string, lng: string },
  markerColor: string,
}
const ToggleableMarkerWithLabel = (props: Props) => {
  const [showLabel, setShowLabel] = React.useState(false);

  const {
    markerProps,
    google,
    messageComp,
    position,
    markerColor,
  } = props;

  const point = new google.maps.Point(0, 0);
  return (
    <MarkerWithLabel
      {...markerProps}
      position={position}
      icon={getColoredMarkerIcon(markerColor)}
      labelAnchor={point}
      labelClass={label}
      labelVisible={showLabel}
      onMouseOver={() => setShowLabel(true)}
      onMouseOut={() => setShowLabel(false)}
      onFocus={() => {}}
      onBlur={() => {}}
    >
      {messageComp}
    </MarkerWithLabel>
  );
};

export default ToggleableMarkerWithLabel;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryMap/Map/ToggleableMarkerWithLabel.jsx